import { connect } from 'react-redux'
import { change as formValueChange } from 'redux-form'
import { withStyles } from '@material-ui/core'
import { compose } from 'redux'
import { SelectAutocompleteBase } from './SelectAutocomplete'

import { styles } from './styles'

const mapDispatchToProps = {
  formValueChange: formValueChange
}

const enhance = compose(
  connect(null, mapDispatchToProps),
  withStyles(styles, { withTheme: true })
)

export const SelectAutocomplete = enhance(SelectAutocompleteBase)



// WEBPACK FOOTER //
// ./src/components/SelectAutocomplete/index.js